import { FsItem } from './fs-item.model';

export class FsItemAdapter extends FsItem {
  constructor(data: Partial<FsItemAdapter> = {}) {
    super(data);
  }
}
